module.exports = __webpack_public_path__ + "static/media/kissing-mascott.c65a7da5.mov";